import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import ChatList from './ChatList';
import ChatMessagePanel from './ChatMessagePanel';
import SidebarNav from './SidebarNav';
import CSServiceUtil from '../../util/CSServiceUtil';
import CSRequestUtil from '../../util/CSRequestUtil';
import CSCOBackdrop from '../CSCOBackdrop';

const gServiceUtil = CSServiceUtil.cfGetInstance();

function CSChatbot(gProps) {
    const [mSelectedChat, setSelectedChat]   = useState(null);
    const [mIsWidgetOpen, setIsWidgetOpen]   = useState(false);
    const [mShowBackdrop, setBackdrop]       = useState(false);
    const [mContacts, setContacts]           = useState(null);
    const [mGroups, setGroups]               = useState(null);
    const [mSaveAction, setSaveAction]       = useState(null);
    const [mReloadAction, setReloadAction]   = useState(null);

    const handleSelectChat = (pChat) => {
        setSelectedChat(pChat);
    };

     const fnHideChatbox = () => {
        gProps.fnProcessClose();
    }

    useEffect(() => {
            const fnInitializeForm = () => {
                let lCriteria = null;
                if(gProps.pFormCriteria){
                }

                if(gProps.pFormProperties){
                }

                if(gProps.pFormActions && (gProps.pFormActions.length > 0)) {
                    for(let lInd=0;  lInd<gProps.pFormActions.length; lInd++) {
                        let lActionItem = gProps.pFormActions[lInd];
                        if(lActionItem.action_ === 'process_search') {
                            let lServiceCode = lActionItem.on_click_service_code_;
                            let lRequestObject = gServiceUtil.cfGetRequestObject(lActionItem.on_click_request_ref_id_);
                            if(lServiceCode || lRequestObject) {
                                let lServiceObject = gServiceUtil.cfGetServiceObject(lServiceCode);
                                if(lServiceObject) {
                                    let lRequestId = null;
                                    if(lRequestObject && lRequestObject.hasOwnProperty('request_id_'))
                                    {
                                        lRequestId = lRequestObject.request_id_;
                                        let lRequestUtil = new CSRequestUtil('GET', lServiceCode, lServiceObject.type_, lRequestId, lServiceObject);
                                        setBackdrop(true);
                                        lRequestUtil.cfSetRequestCriteria(lCriteria);
                                        lRequestUtil.cfProcessRequest((lResponse) =>
                                            {
                                                if(lResponse) {
                                                    setBackdrop(false);
                                                    let lContacts = [] 
                                                    let lGroups   = [] 
                                                    if(lResponse.hasOwnProperty('contacts_')) {
                                                        lContacts = lResponse.contacts_;
                                                        lGroups   = lResponse.groups_;

                                                        setContacts(lContacts);
                                                        setGroups(lGroups);
                                                    }
                                                }
                                            }
                                        );
                                    }
                                }
                            }
                        }
                        else if(lActionItem.action_ === 'process_save') {
                            setSaveAction(lActionItem);
                        }
                        else if(lActionItem.action_ === 'process_reload') {
                            setReloadAction(lActionItem);
                        }
                    }
                }

                if(gProps.pFormItems && (gProps.pFormItems.length > 0)) {
                }
            }
        
            fnInitializeForm();
        }, []
    );

    return (
        <>
            <Button
                onClick    = {() => setIsWidgetOpen(true)}
                aria-label = "Open chat"
                className  = "p-button-rounded p-button-primary text-white"
                visible    = {true} 
                onHide     = {fnHideChatbox}
                style      = {{
                    position  : 'fixed',
                    bottom    : '26px',
                    right     : '16px',
                    zIndex    : 9999,
                    width     : '48px',
                    height    : '48px',
                    boxShadow : '0 6px 18px rgba(11,116,218,0.3)'
                }}
            >
                <i className="pi pi-comments text-gray" style={{ fontSize: '1.2rem' }}></i>
            </Button>

            <Dialog 
                // footer={footerContent}
                header       = "CS Chat" 
                visible      = {mIsWidgetOpen} 
                onHide       = {() => setIsWidgetOpen(false)}
                draggable    = {true}
                resizable    = {true}
                modal        = {true}
                maximizable  = {true}
                className    = "chat-widget-dialog"
                style        = {{ minheight : 'auto', width: '900px' }}
                contentStyle = {{ 
                    height        : '580px', 
                    padding       : '0',
                    bottom        : '0',
                    display       : 'flex',
                    flexDirection : 'column',
                    overflow      : 'hidden'
                }}
            >
                <div style={{ display: 'flex', flex: 1, minHeight: 0, paddingBottom: '2px' }}>
                    <CSCOBackdrop pShow = {mShowBackdrop}/>

                    <div>
                        <SidebarNav />
                    </div>

                    <div style={{ borderRight: '1px solid #eee', maxWidth: '300px'}}>
                        <ChatList 
                            pOnSelectChat = {handleSelectChat} 
                            pSelectedChat = {mSelectedChat}
                            pContacts     = {mContacts} 
                            pGroups       = {mGroups}
                            pProps        = {gProps}/>
                    </div>

                    <div style={{ flex: 1 }}>
                        <ChatMessagePanel pChat = {mSelectedChat} pSaveAction = {mSaveAction} pReloadAction = {mReloadAction}/>
                    </div>
                </div>
            </Dialog>
        </>
    );
}

export default CSChatbot;